import { object, string } from 'zod';

export const schema = object({
  periodo: string().nonempty({ message: 'Digite o periodo de afastamento' }),
  observacoes: string().nonempty(),
});
